<script setup lang="ts">
import { onMounted } from 'vue';

import { startAnalytics } from '../analytics/cookie-consent';
import CapabilitySection from '../components/CapabilitySection.vue';
import CookieBanner from '../components/CookieBanner.vue';
import FaqSection from '../components/FaqSection.vue';
import GuaranteeSection from '../components/GuaranteeSection.vue';
import HeroSection from '../components/HeroSection.vue';
import HowItWorksSection from '../components/HowItWorksSection.vue';
import SiteFooter from '../components/SiteFooter.vue';
import SiteHeader from '../components/SiteHeader.vue';
import '../styles/components.css';

/**
 * La copertina: una pagina sola, in sequenza.
 *
 * Nessun router: le voci dell'indice sono ancore, e i documenti legali sono
 * pagine HTML separate (`/privacy`, `/termini`, `/cookie`) servite dal
 * filesystem. Nessuna chiamata all'API: questo applicativo è statico e deve
 * restare in piedi anche quando l'asta è spenta.
 *
 * L'unica richiesta verso l'esterno è quella della misura d'uso, e parte solo
 * dopo un consenso esplicito.
 */
onMounted(() => {
  startAnalytics();
});
</script>

<template>
  <SiteHeader />
  <main>
    <HeroSection />
    <CapabilitySection />
    <HowItWorksSection />
    <GuaranteeSection />
    <FaqSection />
  </main>
  <SiteFooter />
  <CookieBanner />
</template>
